import { TranslatedCopy } from '../intl/TranslatedCopy';

export const hourOptions = [
  {
    value: '1',
    label: '1'
  },
  {
    value: '2',
    label: '2'
  },
  {
    value: '3',
    label: '3'
  },
  {
    value: '4',
    label: '4'
  },
  {
    value: '5',
    label: '5'
  },
  {
    value: '6',
    label: '6'
  },
  {
    value: '7',
    label: '7'
  },
  {
    value: '8',
    label: '8'
  },
  {
    value: '9',
    label: '9'
  },
  {
    value: '10',
    label: '10'
  },
  {
    value: '11',
    label: '11'
  },
  {
    value: '12',
    label: '12'
  }
];

export const minuteOptions = [
  {
    value: '00',
    label: '00'
  },
  {
    value: '15',
    label: '15'
  },
  {
    value: '30',
    label: '30'
  },
  {
    value: '45',
    label: '45'
  }
];

export const timePeriodOptions = [
  {
    value: 'AM',
    label: 'AM'
  },
  {
    value: 'PM',
    label: 'PM'
  }
];

export const notificationOptions = [
  {
    label: new TranslatedCopy({ id: 'notifications.options.PLANNED_GD_OUTAGE' }).toString(),
    value: 'PLANNED_GD_OUTAGE'
  },
  {
    label: new TranslatedCopy({ id: 'notifications.options.PLANNED_SAP_OUTAGE' }).toString(),
    value: 'PLANNED_SAP_OUTAGE',
    disabled: true
  },
  {
    label: new TranslatedCopy({ id: 'notifications.options.generic' }).toString(),
    value: 'generic',
    disabled: true
  }
];
